
import { cleanPhoneNumber } from '@/components/supplement-info-fields/utils';
import { isSupportedEnvironment } from '@/views_v2/verify-credit/show-contact-icon';
import { Toast } from '@hb/coffee';
import type {
  ContactPermissionStatus,
  ContactInfoResponse,
  SelectContactResult,
} from './types';
import { ContactPermissionStatusEnum } from './types';

const HBridge = import('@hb/hbridge');

/**
 * 检查是否有联系人权限状态
 */
export const checkContactPermission = async (): Promise<ContactPermissionStatusEnum> => {
  if (!isSupportedEnvironment()) {
    // 静默处理版本不支持
  }
  const checkContactPermissionResponse = await (await HBridge).Native.callNative({
    method: 'getContactsPermissionStatus',
    params: {},
    classMap: 'contacts',
  }) as unknown as ContactPermissionStatus;
  return Number(checkContactPermissionResponse.status) as ContactPermissionStatusEnum;
};

/**
 * 打开通讯录选择器
 * @returns 返回结果包含状态和联系人信息（如果成功）
 */
export const openContactPicker = async (): Promise<SelectContactResult> => {
  if (!isSupportedEnvironment()) return {};
  let selectContactResponse: ContactInfoResponse | null = null;
  try {
    selectContactResponse = await (await HBridge).Native.callNative({
      method: 'selectContact',
      params: {},
      classMap: 'contacts',
      timeout: false,
    }) as unknown as ContactInfoResponse;
    const status = Number(selectContactResponse.status) as ContactPermissionStatusEnum;

    // 如果是数据管控状态，显示提示并直接返回状态
    if (status === ContactPermissionStatusEnum.DATA_CONTROL) {
      Toast('导入失败，请前往应用管控中心开启应用权限');
      return {
        status,
      };
    }

    // 如果有联系人信息，返回联系人信息
    if (selectContactResponse.contactInfo) {
      const { fullName, phoneNumber } = selectContactResponse.contactInfo;
      const cleanedPhone = cleanPhoneNumber(phoneNumber || '');
      return {
        status,
        contactInfo: {
          name: fullName || '',
          phone: cleanedPhone,
        },
      };
    }

    // 安卓会返回状态3，表示永久拒绝
    return {
      status,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('平台bridge  selectContact error', error);
    return {};
  }
};

/**
 * 打开系统设置页面
 */

export const openSystemSettings = async (): Promise<void> => {
  if (!isSupportedEnvironment()) return;
  (await HBridge).Native.callNative({
    method: 'openContactsSettings',
    params: {},
    classMap: 'contacts',
  });
};
